import React, { useCallback, useState } from 'react';
import Spinner from '../../../../componentes/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { IStoreRedux } from 'Types/Reducers';
import { post } from '../../../../_axios/requisicao';
import RespostaInesperada from '../RespostaInesperada';
import useTentarNovamente from '../../assets/useTentarNovamente';


function InscricaoHashLink({ useRedis }: any) {
  // const carregando = useSelector((state: IStoreRedux) => state.app.carregando);
  const hash = useSelector((state: IStoreRedux) => state.app.hash);
  const dadosInscricao = useSelector((state: IStoreRedux) => ({
    dados: state.dados,
    contatos: state.contatos,
    endereco: state.endereco,
    termos: state.termos,
  }));

  const dispatch = useDispatch();
  const [carregando, setCarregando] = useState(true);

  const retry = useTentarNovamente(
    useCallback(
      () => {
        // dispatch({ type: 'ALTERA_CARREGANDO', carregando: true });
        setCarregando(true);
        post('api-pessoas', useRedis ? '/redis/inscricoes' : '/inscricoes', dadosInscricao, { hash })
          .then((res) => {
            dispatch({ type: 'ALTERA_INSCRITO', inscrito: res.status === 200 });
            if (!useRedis) dispatch({ type: 'ALTERA_IDPESSOA', idPessoa: res.data.dados.idpessoa })
          })
          // TODO: "armazenar" resposta de pessoa para rediercionar pára escolha de voluntariado
          .finally(() => {
            setCarregando(false);
            // dispatch({ type: 'ALTERA_CARREGANDO', carregando: false })
          });
      },
      [dadosInscricao, dispatch, hash, useRedis]
    )
  );

  return carregando ? <Spinner /> : <RespostaInesperada retry={retry} />;
}

export default InscricaoHashLink;
